import BaseLayout from '../components/base-layout';
import PageUnauthorized from './page-unauthorized';

export function PageUnauthorizedFactory() {
    return (
        <BaseLayout>
            <PageUnauthorized />
        </BaseLayout>
    );
}
